import React, { useState, useEffect, useRef} from 'react';
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap';
import { useUser } from '../../hooks/GlobalUserHooks';
import contractorAvatar from "../../assets/images/users/contractor.png";
import userAvatar from "../../assets/images/users/user.png";
import 'firebase/compat/auth';

const ProfileDropdown = () => {
    const { refreshUserContext, userObject, userName, isContractor } = useUser();
    const [profileData, setProfileData] = useState({
        avatar: userAvatar,
        email: "",
        displayName: ""
    });
    const previousUserRef = useRef<string | null>(null);
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);

    useEffect(() => {
        if (userObject) {
            // Create a unique identifier for the current user state
            const currentUserKey = `${userObject.email}-${userObject.displayName}-${isContractor}`;

            // Only update if the user has changed
            if (currentUserKey !== previousUserRef.current) {
                const defaultAvatar = isContractor ? contractorAvatar : userAvatar;
                const newAvatar = userObject.photoURL || defaultAvatar;
                const newEmail = userObject.email || "";
                const newDisplayName = userName || "";
                
                setProfileData({
                    avatar: newAvatar,
                    email: newEmail,
                    displayName: newDisplayName
                });

                // Update the previous user reference
                previousUserRef.current = currentUserKey;
            }
        }
    }, [userObject, isContractor]);

    // Separate useEffect for initial load and storage events
    useEffect(() => {
        // Initial load
        refreshUserContext();

        // Listen for storage events
        const handleStorageChange = (e: StorageEvent) => {
            if (e.key === 'authUser' || e.key === 'impersonatedUser' || e.key === 'contractor') {
                refreshUserContext();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    return (
        <React.Fragment>
            <Dropdown
                isOpen={isProfileDropdown}
                toggle={toggleProfileDropdown}
                className="ms-sm-3 header-item topbar-user"
            >
                <DropdownToggle tag="button" type="button" className="btn shadow-none">
                    <span className="d-flex align-items-center">
                        <img
                            className="rounded-circle header-profile-user"
                            src={profileData.avatar}
                            alt="Profile"
                            loading="lazy" // Add lazy loading
                            onError={(e) => {
                                const img = e.target as HTMLImageElement;
                                if (!img.classList.contains('fallback-loaded')) {
                                    img.src = isContractor ? contractorAvatar : userAvatar;
                                    img.classList.add('fallback-loaded'); // Add class to prevent multiple retries
                                    img.onerror = null;
                                }
                            }}
                        />
                        <span className="text-start ms-xl-2">
                            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                                {profileData.displayName}
                            </span>
                            <span className="d-none d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                                {profileData.email}
                            </span>
                        </span>
                    </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                    <h6 className="dropdown-header">Welcome {profileData.displayName}!</h6>
                   
                   {/*
                    <DropdownItem href="/profile">
                        <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" />
                        <span className="align-middle">Profile</span>
                    </DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/apps-chat"}><i
                        className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Messages</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "#"}><i
                        className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Taskboard</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-faqs"}><i
                        className="mdi mdi-lifebuoy text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Help</span></DropdownItem>
                    <div className="dropdown-divider"></div>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-profile"}><i
                        className="mdi mdi-wallet text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle">Balance : <b>$5971.67</b></span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/pages-profile-settings"}><span
                        className="badge bg-success-subtle text-success mt-1 float-end">New</span><i
                            className="mdi mdi-cog-outline text-muted fs-16 align-middle me-1"></i> <span
                                className="align-middle">Settings</span></DropdownItem>
                    <DropdownItem href={process.env.PUBLIC_URL + "/auth-lockscreen-basic"}><i
                        className="mdi mdi-lock text-muted fs-16 align-middle me-1"></i> <span className="align-middle">Lock screen</span></DropdownItem>
                    */}

                    <DropdownItem href={process.env.PUBLIC_URL + "/logout"}><i
                        className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i> <span
                            className="align-middle" data-key="t-logout">Logout</span></DropdownItem>
                </DropdownMenu>
            </Dropdown>
        </React.Fragment>
    );
};

export default ProfileDropdown;